import { StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetTwoRows } from "../../Styles/ParticipationTableStyles";

export function EmptyFilter() {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}></StickyHeader>
	)
}